import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import { AvatarSize } from "@shared/types/avatarSize";
import type { User, Avatar } from "@shared/types/graphqlGenerated";

const UserProfile_Shared_Query = gql`
  query UserProfile_Shared_Query($filter: PhotoSizeFilters!) {
    viewer {
      user {
        id
        firstName
        lastName
        fullName
        hasMultipleStorePlatforms
        avatar {
          id
          photoUrl(filter: $filter)
        }
      }
    }
  }
`;

type AvatarSplinter = Pick<Avatar, "id" | "photoUrl">;
type UserSplinter = Pick<
  User,
  "id" | "firstName" | "lastName" | "fullName" | "hasMultipleStorePlatforms"
>;

interface UserProfile extends UserSplinter {
  avatar: AvatarSplinter;
}

interface UserProfileQueryData {
  viewer: {
    user: UserProfile;
  };
}

interface Variables {
  filter?: AvatarSize;
}

const useUserProfileQuery = (
  options: QueryHookOptions<UserProfileQueryData, Variables> = {
    variables: {
      filter: AvatarSize.SMALL,
    },
  }
) => useQuery<UserProfileQueryData>(UserProfile_Shared_Query, options);

export type { UserProfileQueryData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useUserProfileQuery, UserProfile_Shared_Query };
